//=include _bootstrap-datepicker.min.js
//=include _bootstrap-datepicker.fr.min.js

$(document).ready(function() {
	$('.toggle_form').on('click', function(e) {
		e.preventDefault();
		$('.section_candidature_form').slideToggle();
	});

	$('.date-picker').datepicker({
		language: 'fr'
	});
});
